import axios from 'axios';
import { SetterOrUpdater, useRecoilState } from 'recoil';
import { ReviewFamilyParams } from '../../models/ReviewFamilyParams.model';
import { HoneyloveReview, HoneyloveReviewSet } from '../../models/HoneyloveReview.model';
import { HoneyloveWindow } from '../../models/HoneyloveWindow';
import { KVP } from '../../util';
import { reviewFamily } from '../../recoil/atoms';

const memo: KVP<boolean | HoneyloveReviewSet> = {};
const cacheKey = (props: ReviewFamilyParams): string => JSON.stringify(props);

const isReview = (reviewOrBoolean: HoneyloveReviewSet | boolean): reviewOrBoolean is HoneyloveReviewSet => {
  return reviewOrBoolean !== true && reviewOrBoolean !== false;
};

export const useSharedGetReviewState = (props: ReviewFamilyParams): { reviewSet: HoneyloveReviewSet; allReviews: HoneyloveReview[] } => {
  const [reviewSet, set] = useRecoilState(reviewFamily(props));
  const key = cacheKey(props);
  if (!memo[key]) {
    memo[key] = true;
    getReviews(props, set);
  }
  return {
    reviewSet,
    allReviews: Object.keys(memo).reduce((acc, curr) => {
      const possibleReviewSet = memo[curr];
      if (!isReview(possibleReviewSet)) return acc;
      const cachedProps = JSON.parse(curr) as ReviewFamilyParams;
      if (cachedProps.productId !== props.productId || cachedProps.itemsPerPage !== props.itemsPerPage) return acc;

      return [...acc, ...(possibleReviewSet.reviews ?? [])];
    }, [] as HoneyloveReview[]),
  };
};

declare const window: HoneyloveWindow;
const getReviews = (props: ReviewFamilyParams, set: SetterOrUpdater<HoneyloveReviewSet>): void => {
  const dataApiDomain = window.Honeylove.environment.dataApiDomain; //process.env.NEXT_PUBLIC_DATA_API_DOMAIN;
  const url = `https://${dataApiDomain}/api/reviews?product=${props.productId}&page=${props.page}&count=${props.itemsPerPage}`;
  axios
    .get(url)
    .then(({ data }: { data: HoneyloveReviewSet }) => {
      set(data);
      memo[cacheKey(props)] = data;
    })
    .catch((error: any) => {
      // eslint-disable-next-line no-console
      console.log('Error fetching reviews', error);
    });
};
